export default __webpack_public_path__ + "static/media/marker.531cbd0d.svg";